import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { refreshPricingInventory } from "@src/store/pricing/refreshPricingInventory";

const initialState = false;
export interface IListingToUpdate {
	ListingId: string;
	QuantityToSplit: string;
	PriceOfGroup: string;
}

export const { thunk: updateSplitListing, slice: updateSplitListingSlice } = getThunkAndSlice<
	IListingToUpdate,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/SplitListing",
	method: "post",
	onAfterRequest: async (data, _params, _state, dispatch) => {
		dispatch(refreshPricingInventory());
		return data;
	},
});
